import { render } from "./InspecaoIndicadores.vue?vue&type=template&id=fb0d3078&scoped=true"
import script from "./InspecaoIndicadores.vue?vue&type=script&lang=js"
export * from "./InspecaoIndicadores.vue?vue&type=script&lang=js"

import "./InspecaoIndicadores.vue?vue&type=style&index=0&id=fb0d3078&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb0d3078"]])

export default __exports__